__webpack_public_path__=(window['__webpack_public_path__'] + '////assets/plugin-web-account5/').replace(/[/]{3,}/g, "/");